(() => {
  'use strict';
  const initialize = () => {
    if (!document.body || !document.querySelector('[data-kiwabi-sticky-cart]')) return;
    document.querySelectorAll('[data-kiwabi-sticky-cart]:not([data-kiwabi-initialized])').forEach(bar => {
      const form = document.getElementById(bar.dataset.formId);
      const nativeButton = form && form.querySelector('[data-add-to-cart]');
      if (!form || !nativeButton) return;
      bar.dataset.kiwabiInitialized = 'true';
      const stickyButton = bar.querySelector('[data-kiwabi-sticky-add]');
      const label = bar.querySelector('[data-kiwabi-sticky-label]');
      const status = bar.querySelector('.kiwabi-sticky-cart__status');
      document.body.appendChild(bar);
      let pending = false;
      let frame = 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const labelText = () => (nativeButton.querySelector('[data-add-to-cart-text]')?.textContent || '').trim();
      const unavailable = () => /売り切れ|在庫切れ|sold\s*out|unavailable/i.test(labelText());
      const colorRequired = bar.dataset.kiwabiColorRequired === 'true';
      const productSection = form.closest('[data-section-type="product"]') || document.querySelector('[data-section-type="product"][data-product-handle]');
      const colorButtons = Array.from(bar.querySelectorAll('[data-kiwabi-color-value]'));
      const colorCurrent = bar.querySelector('[data-kiwabi-color-current]');
      let chosenColor = null;
      let variants = [];
      try { variants = JSON.parse(form.querySelector('[data-product-json]')?.textContent || '{}').variants || []; } catch { variants = []; }
      const findColorField = () => productSection?.querySelector('.selector-wrapper[data-select-label="色"]');
      const getNativeColor = () => findColorField()?.querySelector('input[name="options[色]"]:checked, input[data-single-option-selector]')?.value || '';
      const setChosenColor = color => {
        if (!colorRequired || !colorButtons.some(button => button.dataset.kiwabiColorValue === color)) return;
        chosenColor = color;
        colorButtons.forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.kiwabiColorValue === color)); });
        if (colorCurrent) colorCurrent.textContent = 'カラー：' + color;
        status.textContent = '選択したカラー：' + color;
        updateButton();
      };
      const nativeVariantMatches = () => {
        if (!colorRequired) return true;
        if (!chosenColor || getNativeColor() !== chosenColor || !variants.length) return false;
        const id = form.querySelector('input[name="id"]')?.value;
        const variant = variants.find(item => String(item.id) === String(id));
        if (!variant || variant.available === false) return false;
        const wrappers = Array.from(productSection?.querySelectorAll('.form__selectors [data-split-select-wrapper]') || []);
        wrappers.sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
        const selectedOptions = wrappers.map(wrapper => wrapper.querySelector('input[type="radio"][name^="options["]:checked, input[data-single-option-selector]')?.value || '');
        return selectedOptions.length === variant.options.length && selectedOptions.every((value, index) => Boolean(value) && value === variant.options[index]);
      };
      const waitForNativeVariant = async color => {
        for (let i = 0; i < 12; i += 1) {
          if (chosenColor !== color) return false;
          if (nativeVariantMatches()) return true;
          await new Promise(resolve => window.setTimeout(resolve, 50));
        }
        return false;
      };
      if (colorRequired) {
        colorButtons.forEach(button => {
          button.addEventListener('click', () => {
            const value = button.dataset.kiwabiColorValue;
            const input = Array.from(findColorField()?.querySelectorAll('input[name="options[色]"]') || [])
              .find(item => item.value === value);
            if (!input || input.disabled) {
              status.textContent = 'このカラーを選択できません。';
              return;
            }
            setChosenColor(value);
            input.click();
          });
        });
        const acceptNativeChoice = event => {
          if (!event.isTrusted || !(event.target instanceof Element)) return;
          const input = event.target.matches('input[name="options[色]"]')
            ? event.target
            : (event.target.closest('label[for]') && document.getElementById(event.target.closest('label[for]').htmlFor));
          if (input?.name === 'options[色]' && input.closest('.selector-wrapper[data-select-label="色"]')) setChosenColor(input.value);
        };
        productSection?.addEventListener('click', acceptNativeChoice, true);
        productSection?.addEventListener('change', acceptNativeChoice, true);
      }
      const updateButton = () => {
        const soldOut = unavailable();
        stickyButton.disabled = soldOut || pending;
        label.textContent = soldOut ? '売り切れ' : (pending ? '確認中…' : (colorRequired && !chosenColor ? '色を選ぶ' : (bar.dataset.preorder === 'true' ? '予約注文する' : 'カートに入れる')));
      };
      const synchronizePointBadge = () => {
        const visibleBar = document.querySelector('[data-kiwabi-sticky-cart]:not([hidden])');
        document.body.classList.toggle('kiwabi-sticky-cart-visible', Boolean(visibleBar));
        if (visibleBar) {
          const height = Math.ceil(visibleBar.getBoundingClientRect().height);
          document.body.style.setProperty('--kiwabi-sticky-cart-offset', `${height + 16}px`);
        } else {
          document.body.style.removeProperty('--kiwabi-sticky-cart-offset');
        }
      };
      const updateVisibility = () => {
        frame = 0;
        if (!nativeButton.isConnected || !form.isConnected) {
          bar.hidden = true;
          synchronizePointBadge();
          return;
        }
        const bounds = nativeButton.getBoundingClientRect();
        const belowNativeButton = bounds.bottom < 0 && window.scrollY > 160;
        const footer = document.querySelector('.theme__footer, footer');
        const overlapsFooter = footer && footer.getBoundingClientRect().top < window.innerHeight;
        const drawerOpen = !!document.querySelector('.drawer.is-open, .drawer--open, .drawer.drawer--visible');
        bar.hidden = !(belowNativeButton && !overlapsFooter && !drawerOpen);
        synchronizePointBadge();
      };
      const scheduleVisibility = () => {
        if (frame) return;
        frame = requestAnimationFrame(updateVisibility);
      };
      stickyButton.addEventListener('click', async () => {
        if (pending || unavailable()) return;
        if (colorRequired && !chosenColor) {
          status.textContent = '購入するカラーを選択してください。';
          if (colorCurrent) colorCurrent.textContent = 'カラーを選択してください';
          colorButtons[0]?.focus();
          return;
        }
        if (nativeButton.disabled) {
          status.textContent = 'カラー・購入方法・同意事項をご確認ください。';
          form.closest('[data-form-holder]')?.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'center' });
          const agreement = document.querySelector('input[name="kiwabi-agree"]');
          if (agreement && !agreement.checked) {
            agreement.closest('label')?.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'center' });
          } else {
            nativeButton.focus({ preventScroll: true });
          }
          return;
        }
        pending = true;
        updateButton();
        const requestedColor = chosenColor;
        const correctlySynced = !colorRequired || await waitForNativeVariant(requestedColor);
        if (!correctlySynced || nativeButton.disabled || unavailable()) {
          pending = false;
          updateButton();
          status.textContent = '選択内容が反映されませんでした。商品画面のカラー・本数をご確認ください。';
          if (colorCurrent) colorCurrent.textContent = 'カラーの確認が必要です';
          findColorField()?.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'center' });
          return;
        }
        nativeButton.click();
        window.setTimeout(() => { pending = false; updateButton(); scheduleVisibility(); }, 1100);
      });
      const observer = new MutationObserver(() => updateButton());
      observer.observe(nativeButton, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      form.addEventListener('change', updateButton);
      window.addEventListener('scroll', scheduleVisibility, { passive: true });
      window.addEventListener('resize', scheduleVisibility, { passive: true });
      document.addEventListener('shopify:section:load', scheduleVisibility);
      updateButton();
      scheduleVisibility();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
